export type DisplacedPersonInfo = {
  sessionName?: string | null;
  otherNote?: string | null;
  field1?: string | null;
  isReturnee?: boolean | null;
};

const CAMP_BY_SESSION: Record<string, string> = {
  alfaf: "Al-Amal Camp",
  akhtarin: "Akhtarin",
  sfrsd: "SFRSD",
};

const normalizeSession = (sessionName?: string | null): string | null => {
  const value = sessionName?.trim();
  if (!value) return null;
  if (/^alfaf$/i.test(value)) return "Alfaf";
  if (/^akhtarin$/i.test(value)) return "Akhtarin";
  if (/^sfrsd$/i.test(value)) return "SFRSD";
  return value;
};

const resolveCampName = (
  displacedPerson: DisplacedPersonInfo,
  session: string | null
): string | null => {
  if (session) {
    const mapped = CAMP_BY_SESSION[session.toLowerCase()];
    if (mapped) return mapped;
  }

  if (
    /Al-Amal|الفاف|leave camp/i.test(displacedPerson.otherNote ?? "") ||
    /Al-Amal|leave camp/i.test(displacedPerson.field1 ?? "")
  ) {
    return "Al-Amal Camp";
  }

  return null;
};

/** Human-readable label for the running-call banner. */
export const formatDisplacedPersonLabel = (
  displacedPerson: DisplacedPersonInfo | null | undefined
): string | null => {
  if (!displacedPerson) return null;

  const session = normalizeSession(displacedPerson.sessionName);
  const camp = resolveCampName(displacedPerson, session);

  if (camp && session) {
    return `نازح في ${camp} · يحضر جلسة ${session}`;
  }
  if (camp) {
    return `نازح في ${camp}`;
  }
  if (session) {
    return `نازح · يحضر جلسة ${session}`;
  }
  return "شخص نازح";
};
